import Svg2Layers from "./2Layers.tsx";
import Svg3Layers from "./3Layers.tsx";
import AmexBadge from "./AmexBadge.tsx";
import AILogo from "./AILogo.tsx";
import CallQueue from "./CallQueue.tsx";
import CallMonitoring from "./CallMonitoring.tsx";
import CallRouting from "./CallRouting.tsx";
import Circle from "./Circle.tsx";
import FiltersLines from "./FiltersLines.tsx";
import Ivr from "./Ivr.tsx";
import IconIntercom from "./IconIntercom.tsx";
import IconMsTeams from "./IconMsTeams.tsx";
import IconMicrosoft3652022 from "./IconMicrosoft3652022.tsx";
import IconAw3 from "./IconAw3.tsx";
import IconAzure from "./IconAzure.tsx";
import IconCapsule from "./IconCapsule.tsx";
import IconChrome from "./IconChrome.tsx";
import IconDropbox from "./IconDropbox.tsx";
import IconFirefox from "./IconFirefox.tsx";
import IconGoogle from "./IconGoogle.tsx";
import IconGoogleContacts from "./IconGoogleContacts.tsx";
import IconGoogleDrive from "./IconGoogleDrive.tsx";
import IconHubspot from "./IconHubspot.tsx";
import IconPipedrive from "./IconPipedrive.tsx";
import IconSalesforce from "./IconSalesforce.tsx";
import IconSlack from "./IconSlack.tsx";
import IconVincere from "./IconVincere.tsx";
import IconVtiger from "./IconVtiger.tsx";
import IconZoho from "./IconZoho.tsx";
import LogoActiveCampaign from "./LogoActiveCampaign.tsx";
import LogoAdobe from "./LogoAdobe.tsx";
import LogoAfterpay from "./LogoAfterpay.tsx";
import LogoAirbnb from "./LogoAirbnb.tsx";
import LogoAirtable from "./LogoAirtable.tsx";
import LogoAirtasker from "./LogoAirtasker.tsx";
import LogoAirwallex from "./LogoAirwallex.tsx";
import LogoAmazon from "./LogoAmazon.tsx";
import LogoAmplitude from "./LogoAmplitude.tsx";
import LogoAsana from "./LogoAsana.tsx";
import LogoAtlassian from "./LogoAtlassian.tsx";
import LogoAttentive from "./LogoAttentive.tsx";
import LogoAutomattic from "./LogoAutomattic.tsx";
import LogoBasecamp from "./LogoBasecamp.tsx";
import LogoBookingCom from "./LogoBookingCom.tsx";
import LogoBraze from "./LogoBraze.tsx";
import LogoBrowserStack from "./LogoBrowserStack.tsx";
import LogoCalendly from "./LogoCalendly.tsx";
import LogoCallcabinet from "./LogoCallcabinet.tsx";
import LogoCanva from "./LogoCanva.tsx";
import LogoCapsule from "./LogoCapsule.tsx";
import LogoCarta from "./LogoCarta.tsx";
import LogoChrome from "./LogoChrome.tsx";
import LogoClasspass from "./LogoClasspass.tsx";
import LogoClearbit from "./LogoClearbit.tsx";
import LogoCodecademy from "./LogoCodecademy.tsx";
import LogoCoinbase from "./LogoCoinbase.tsx";
import LogoCommsBusiness from "./LogoCommsBusiness.tsx";
import LogoCommsDealer from "./LogoCommsDealer.tsx";
import LogoContentful from "./LogoContentful.tsx";
import LogoCultureAmp from "./LogoCultureAmp.tsx";
import LogoCustomerIo from "./LogoCustomerIo.tsx";
import LogoDatabricks from "./LogoDatabricks.tsx";
import LogoDescript from "./LogoDescript.tsx";
import LogoDiscord from "./LogoDiscord.tsx";
import LogoDocker from "./LogoDocker.tsx";
import LogoDocusign from "./LogoDocusign.tsx";
import LogoDoorDash from "./LogoDoorDash.tsx";
import LogoDribbble from "./LogoDribbble.tsx";
import LogoDrips from "./LogoDrips.tsx";
import LogoDropbox from "./LogoDropbox.tsx";
import LogoElastic from "./LogoElastic.tsx";
import LogoEvernote from "./LogoEvernote.tsx";
import LogoFigma from "./LogoFigma.tsx";
import LogoFirefoxBrowser from "./LogoFirefoxBrowser.tsx";
import LogoFivetran from "./LogoFivetran.tsx";
import LogoFramer from "./LogoFramer.tsx";
import LogoFreshworks from "./LogoFreshworks.tsx";
import LogoGhost from "./LogoGhost.tsx";
import LogoGitHub from "./LogoGitHub.tsx";
import LogoGitlab from "./LogoGitlab.tsx";
import LogoGong from "./LogoGong.tsx";
import LogoGoogle from "./LogoGoogle.tsx";
import LogoGrammarly from "./LogoGrammarly.tsx";
import LogoGumroad from "./LogoGumroad.tsx";
import LogoGusto from "./LogoGusto.tsx";
import LogoHashiCorp from "./LogoHashiCorp.tsx";
import LogoHellosign from "./LogoHellosign.tsx";
import LogoHimalayas from "./LogoHimalayas.tsx";
import LogoHopin from "./LogoHopin.tsx";
import LogoHotjar from "./LogoHotjar.tsx";
import LogoHubspot from "./LogoHubspot.tsx";
import LogoInVision from "./LogoInVision.tsx";
import LogoInstagram from "./LogoInstagram.tsx";
import LogoIntercom from "./LogoIntercom.tsx";
import LogoLattice from "./LogoLattice.tsx";
import LogoLaunchDarkly from "./LogoLaunchDarkly.tsx";
import LogoLinear from "./LogoLinear.tsx";
import LogoLoom from "./LogoLoom.tsx";
import LogoMailchimp from "./LogoMailchimp.tsx";
import LogoMaze from "./LogoMaze.tsx";
import LogoMedium from "./LogoMedium.tsx";
import LogoMicrosoft from "./LogoMicrosoft.tsx";
import LogoMiro from "./LogoMiro.tsx";
import LogoMondayCom from "./LogoMondayCom.tsx";
import LogoMonzo from "./LogoMonzo.tsx";
import LogoMsTeams from "./LogoMsTeams.tsx";
import LogoNetflix from "./LogoNetflix.tsx";
import LogoNotion from "./LogoNotion.tsx";
import LogoOffice365 from "./LogoOffice365.tsx";
import LogoOpendoor from "./LogoOpendoor.tsx";
import LogoOutreach from "./LogoOutreach.tsx";
import LogoPayPal from "./LogoPayPal.tsx";
import LogoPendo from "./LogoPendo.tsx";
import LogoPipedrive from "./LogoPipedrive.tsx";
import LogoPlaid from "./LogoPlaid.tsx";
import LogoPostman from "./LogoPostman.tsx";
import LogoProductboard from "./LogoProductboard.tsx";
import LogoRazorpay from "./LogoRazorpay.tsx";
import LogoRippling from "./LogoRippling.tsx";
import LogoSalesforce from "./LogoSalesforce.tsx";
import LogoSegment from "./LogoSegment.tsx";
import LogoShopify from "./LogoShopify.tsx";
import LogoSlack from "./LogoSlack.tsx";
import LogoSonos from "./LogoSonos.tsx";
import LogoSpaceX from "./LogoSpaceX.tsx";
import LogoSplunk from "./LogoSplunk.tsx";
import LogoSpotify from "./LogoSpotify.tsx";
import LogoSquare from "./LogoSquare.tsx";
import LogoSquarespace from "./LogoSquarespace.tsx";
import LogoStripe from "./LogoStripe.tsx";
import LogoTesla from "./LogoTesla.tsx";
import LogoTinder from "./LogoTinder.tsx";
import LogoToggle from "./LogoToggle.tsx";
import LogoTreehouse from "./LogoTreehouse.tsx";
import LogoTrello from "./LogoTrello.tsx";
import LogoTrustpilot from "./LogoTrustpilot.tsx";
import LogoTwitch from "./LogoTwitch.tsx";
import LogoUber from "./LogoUber.tsx";
import LogoUpwork from "./LogoUpwork.tsx";
import LogoVincare from "./LogoVincare.tsx";
import LogoWealthsimple from "./LogoWealthsimple.tsx";
import LogoWebflow from "./LogoWebflow.tsx";
import LogoWhatsapp from "./LogoWhatsapp.tsx";
import LogoXero from "./LogoXero.tsx";
import LogoYouTube from "./LogoYouTube.tsx";
import LogoZapier from "./LogoZapier.tsx";
import LogoZoho from "./LogoZoho.tsx";
import LogoZoom from "./LogoZoom.tsx";
import LogoAppleSafariAr211 from "./LogoAppleSafariAr211.tsx";
import LogoReapitLogo1 from "./LogoReapitLogo1.tsx";
import LogoVtiger from "./LogoVtiger.tsx";
import MaestroBadge from "./MaestroBadge.tsx";
import MasterCardBadge from "./MasterCardBadge.tsx";
import PaypalBadge from "./PaypalBadge.tsx";
import VisaBadge from "./VisaBadge.tsx";
import Wallboards from "./Wallboards.tsx";
import Activity from "./Activity.tsx";
import Airplay from "./Airplay.tsx";
import AlertCircle from "./AlertCircle.tsx";
import AlertOctagon from "./AlertOctagon.tsx";
import AlertTriangle from "./AlertTriangle.tsx";
import AlignCenter from "./AlignCenter.tsx";
import AlignJustify from "./AlignJustify.tsx";
import AlignLeft from "./AlignLeft.tsx";
import AlignRight from "./AlignRight.tsx";
import AmexBlock from "./AmexBlock.tsx";
import Anchor from "./Anchor.tsx";
import Aperture from "./Aperture.tsx";
import AppstoreCard from "./AppstoreCard.tsx";
import Archive from "./Archive.tsx";
import ArrowDownCircle from "./ArrowDownCircle.tsx";
import ArrowDownLeft from "./ArrowDownLeft.tsx";
import ArrowDownRight from "./ArrowDownRight.tsx";
import ArrowDown from "./ArrowDown.tsx";
import ArrowLeftCircle from "./ArrowLeftCircle.tsx";
import ArrowLeft from "./ArrowLeft.tsx";
import ArrowRightCircle from "./ArrowRightCircle.tsx";
import ArrowRight from "./ArrowRight.tsx";
import ArrowUpCircle from "./ArrowUpCircle.tsx";
import ArrowUpLeft from "./ArrowUpLeft.tsx";
import ArrowUpRight from "./ArrowUpRight.tsx";
import ArrowUp from "./ArrowUp.tsx";
import AtSign from "./AtSign.tsx";
import Award from "./Award.tsx";
import BarChart2 from "./BarChart2.tsx";
import BarChart from "./BarChart.tsx";
import BatteryCharging from "./BatteryCharging.tsx";
import Battery from "./Battery.tsx";
import BellOff from "./BellOff.tsx";
import Bell from "./Bell.tsx";
import Bluetooth from "./Bluetooth.tsx";
import Bold from "./Bold.tsx";
import BookOpen from "./BookOpen.tsx";
import Book from "./Book.tsx";
import Bookmark from "./Bookmark.tsx";
import Box from "./Box.tsx";
import Briefcase from "./Briefcase.tsx";
import Calendar from "./Calendar.tsx";
import CameraOff from "./CameraOff.tsx";
import Camera from "./Camera.tsx";
import Cast from "./Cast.tsx";
import CheckCircle from "./CheckCircle.tsx";
import CheckSquare from "./CheckSquare.tsx";
import Check from "./Check.tsx";
import ChevronDown from "./ChevronDown.tsx";
import ChevronLeft from "./ChevronLeft.tsx";
import ChevronRight from "./ChevronRight.tsx";
import ChevronUp from "./ChevronUp.tsx";
import ChevronsDown from "./ChevronsDown.tsx";
import ChevronsLeft from "./ChevronsLeft.tsx";
import ChevronsRight from "./ChevronsRight.tsx";
import ChevronsUp from "./ChevronsUp.tsx";
import Chrome from "./Chrome.tsx";
import Clipboard from "./Clipboard.tsx";
import Clock from "./Clock.tsx";
import CloudDrizzle from "./CloudDrizzle.tsx";
import CloudLightning from "./CloudLightning.tsx";
import CloudOff from "./CloudOff.tsx";
import CloudRain from "./CloudRain.tsx";
import CloudSnow from "./CloudSnow.tsx";
import Cloud from "./Cloud.tsx";
import Code from "./Code.tsx";
import Codepen from "./Codepen.tsx";
import Codesandbox from "./Codesandbox.tsx";
import Coffee from "./Coffee.tsx";
import CoinStack from "./CoinStack.tsx";
import Coins from "./Coins.tsx";
import Columns from "./Columns.tsx";
import Command from "./Command.tsx";
import Compass from "./Compass.tsx";
import Copy from "./Copy.tsx";
import CornerDownLeft from "./CornerDownLeft.tsx";
import CornerDownRight from "./CornerDownRight.tsx";
import CornerLeftDown from "./CornerLeftDown.tsx";
import CornerLeftUp from "./CornerLeftUp.tsx";
import CornerRightDown from "./CornerRightDown.tsx";
import CornerRightUp from "./CornerRightUp.tsx";
import CornerUpLeft from "./CornerUpLeft.tsx";
import CornerUpRight from "./CornerUpRight.tsx";
import Cpu from "./Cpu.tsx";
import CreditCard from "./CreditCard.tsx";
import Crop from "./Crop.tsx";
import Crosshair from "./Crosshair.tsx";
import Database from "./Database.tsx";
import Delete from "./Delete.tsx";
import Disc from "./Disc.tsx";
import DivideCircle from "./DivideCircle.tsx";
import DivideSquare from "./DivideSquare.tsx";
import Divide from "./Divide.tsx";
import DollarSign from "./DollarSign.tsx";
import DownloadCloud from "./DownloadCloud.tsx";
import Download from "./Download.tsx";
import Dribbble from "./Dribbble.tsx";
import Droplet from "./Droplet.tsx";
import Edit2 from "./Edit2.tsx";
import Edit3 from "./Edit3.tsx";
import Edit from "./Edit.tsx";
import ExternalLink from "./ExternalLink.tsx";
import EyeOff from "./EyeOff.tsx";
import Eye from "./Eye.tsx";
import FacebookGrey from "./FacebookGrey.tsx";
import Facebook from "./Facebook.tsx";
import FastForward from "./FastForward.tsx";
import Feather from "./Feather.tsx";
import Figma from "./Figma.tsx";
import FileMinus from "./FileMinus.tsx";
import FilePlus from "./FilePlus.tsx";
import FileText from "./FileText.tsx";
import File from "./File.tsx";
import Film from "./Film.tsx";
import Filter from "./Filter.tsx";
import Flag from "./Flag.tsx";
import FolderMinus from "./FolderMinus.tsx";
import FolderPlus from "./FolderPlus.tsx";
import Folder from "./Folder.tsx";
import Framer from "./Framer.tsx";
import Frown from "./Frown.tsx";
import Gift from "./Gift.tsx";
import GitBranch from "./GitBranch.tsx";
import GitCommit from "./GitCommit.tsx";
import GitMerge from "./GitMerge.tsx";
import GitPullRequest from "./GitPullRequest.tsx";
import Github from "./Github.tsx";
import Gitlab from "./Gitlab.tsx";
import Globe from "./Globe.tsx";
import Google from "./Google.tsx";
import GoogleplayCard from "./GoogleplayCard.tsx";
import Gov from "./Gov.tsx";
import Grid from "./Grid.tsx";
import HardDrive from "./HardDrive.tsx";
import Hash from "./Hash.tsx";
import Headphones from "./Headphones.tsx";
import Heart from "./Heart.tsx";
import HelpCircle from "./HelpCircle.tsx";
import Hexagon from "./Hexagon.tsx";
import Home from "./Home.tsx";
import Image from "./Image.tsx";
import Inbox from "./Inbox.tsx";
import Info from "./Info.tsx";
import InstagramGrey from "./InstagramGrey.tsx";
import Instagram from "./Instagram.tsx";
import Iso22301 from "./Iso22301.tsx";
import Iso27001 from "./Iso27001.tsx";
import Italic from "./Italic.tsx";
import Key from "./Key.tsx";
import Layout from "./Layout.tsx";
import LifeBuoy from "./LifeBuoy.tsx";
import Link2 from "./Link2.tsx";
import Link from "./Link.tsx";
import LinkedinGrey from "./LinkedinGrey.tsx";
import Linkedin from "./Linkedin.tsx";
import List from "./List.tsx";
import Loader from "./Loader.tsx";
import Lock from "./Lock.tsx";
import LogIn from "./LogIn.tsx";
import LogOut from "./LogOut.tsx";
import Mail from "./Mail.tsx";
import MapPin from "./MapPin.tsx";
import Map from "./Map.tsx";
import MastercardBlock from "./MastercardBlock.tsx";
import Maximize2 from "./Maximize2.tsx";
import Maximize from "./Maximize.tsx";
import Meh from "./Meh.tsx";
import Menu2 from "./Menu2.tsx";
import Menu from "./Menu.tsx";
import MessageCircle from "./MessageCircle.tsx";
import MessageSquare from "./MessageSquare.tsx";
import MicOff from "./MicOff.tsx";
import Mic from "./Mic.tsx";
import Microsoft from "./Microsoft.tsx";
import Minimize2 from "./Minimize2.tsx";
import Minimize from "./Minimize.tsx";
import MinusCircle from "./MinusCircle.tsx";
import MinusSquare from "./MinusSquare.tsx";
import Minus from "./Minus.tsx";
import MonitorMobbile from "./MonitorMobbile.tsx";
import Monitor from "./Monitor.tsx";
import Moon from "./Moon.tsx";
import MoreHorizontal from "./MoreHorizontal.tsx";
import MoreVertical from "./MoreVertical.tsx";
import MousePointer from "./MousePointer.tsx";
import Move from "./Move.tsx";
import Music from "./Music.tsx";
import Navigation2 from "./Navigation2.tsx";
import Navigation from "./Navigation.tsx";
import Octagon from "./Octagon.tsx";
import Package from "./Package.tsx";
import Paperclip from "./Paperclip.tsx";
import PauseCircle from "./PauseCircle.tsx";
import Pause from "./Pause.tsx";
import PaypalBlock from "./PaypalBlock.tsx";
import PenTool from "./PenTool.tsx";
import Percent from "./Percent.tsx";
import PhoneCall from "./PhoneCall.tsx";
import PhoneForwarded from "./PhoneForwarded.tsx";
import PhoneIncoming from "./PhoneIncoming.tsx";
import PhoneMissed from "./PhoneMissed.tsx";
import PhoneOff from "./PhoneOff.tsx";
import PhoneOutgoing from "./PhoneOutgoing.tsx";
import Phone from "./Phone.tsx";
import PieChart from "./PieChart.tsx";
import PlayCircle from "./PlayCircle.tsx";
import Play from "./Play.tsx";
import PlusCircle from "./PlusCircle.tsx";
import PlusSquare from "./PlusSquare.tsx";
import Plus from "./Plus.tsx";
import Pocket from "./Pocket.tsx";
import Power from "./Power.tsx";
import Printer from "./Printer.tsx";
import Radio from "./Radio.tsx";
import RefreshCcw from "./RefreshCcw.tsx";
import RefreshCw from "./RefreshCw.tsx";
import Repeat from "./Repeat.tsx";
import Rewind from "./Rewind.tsx";
import Rocket from "./Rocket.tsx";
import RotateCcw from "./RotateCcw.tsx";
import RotateCw from "./RotateCw.tsx";
import Rss from "./Rss.tsx";
import Save from "./Save.tsx";
import Scissors from "./Scissors.tsx";
import Search from "./Search.tsx";
import Send from "./Send.tsx";
import Server from "./Server.tsx";
import Settings from "./Settings.tsx";
import Share2 from "./Share2.tsx";
import Share from "./Share.tsx";
import ShieldOff from "./ShieldOff.tsx";
import Shield from "./Shield.tsx";
import ShoppingBag from "./ShoppingBag.tsx";
import ShoppingCart from "./ShoppingCart.tsx";
import Shuffle from "./Shuffle.tsx";
import Sidebar from "./Sidebar.tsx";
import SkipBack from "./SkipBack.tsx";
import SkipForward from "./SkipForward.tsx";
import Slack from "./Slack.tsx";
import SlashDivider from "./SlashDivider.tsx";
import Slash from "./Slash.tsx";
import Sliders from "./Sliders.tsx";
import Smartphone from "./Smartphone.tsx";
import Smile from "./Smile.tsx";
import Speaker from "./Speaker.tsx";
import Square from "./Square.tsx";
import Star from "./Star.tsx";
import StopCircle from "./StopCircle.tsx";
import Sun from "./Sun.tsx";
import Sunrise from "./Sunrise.tsx";
import Sunset from "./Sunset.tsx";
import Tablet from "./Tablet.tsx";
import Tag from "./Tag.tsx";
import Target from "./Target.tsx";
import Terminal from "./Terminal.tsx";
import Thermometer from "./Thermometer.tsx";
import ThumbsDown from "./ThumbsDown.tsx";
import ThumbsUp from "./ThumbsUp.tsx";
import ToggleLeft from "./ToggleLeft.tsx";
import ToggleRight from "./ToggleRight.tsx";
import Tool from "./Tool.tsx";
import Trash2 from "./Trash2.tsx";
import Trash from "./Trash.tsx";
import Trello from "./Trello.tsx";
import TrendingDown from "./TrendingDown.tsx";
import TrendingUp from "./TrendingUp.tsx";
import Triangle from "./Triangle.tsx";
import Truck from "./Truck.tsx";
import Tv from "./Tv.tsx";
import Twitch from "./Twitch.tsx";
import Twitter from "./Twitter.tsx";
import Type from "./Type.tsx";
import Umbrella from "./Umbrella.tsx";
import Underline from "./Underline.tsx";
import Unlock from "./Unlock.tsx";
import UploadCloud from "./UploadCloud.tsx";
import Upload from "./Upload.tsx";
import UserCheck from "./UserCheck.tsx";
import UserMinus from "./UserMinus.tsx";
import UserPlus from "./UserPlus.tsx";
import UserX from "./UserX.tsx";
import User from "./User.tsx";
import Users from "./Users.tsx";
import VideoOff from "./VideoOff.tsx";
import Video from "./Video.tsx";
import VisaBlock from "./VisaBlock.tsx";
import Voicemail from "./Voicemail.tsx";
import Volume1 from "./Volume1.tsx";
import Volume2 from "./Volume2.tsx";
import VolumeX from "./VolumeX.tsx";
import Volume from "./Volume.tsx";
import Watch from "./Watch.tsx";
import WifiOff from "./WifiOff.tsx";
import Wifi from "./Wifi.tsx";
import Wind from "./Wind.tsx";
import XCircle from "./XCircle.tsx";
import XGrey from "./XGrey.tsx";
import XOctagon from "./XOctagon.tsx";
import XSquare from "./XSquare.tsx";
import X from "./X.tsx";
import YoutubeGrey from "./YoutubeGrey.tsx";
import Youtube from "./Youtube.tsx";
import ZapOff from "./ZapOff.tsx";
import Zap from "./Zap.tsx";
import ZoomIn from "./ZoomIn.tsx";
import ZoomOut from "./ZoomOut.tsx";
import CyberEssentials from "./CyberEssentials.tsx";
import CheckedCircle from "./CheckedCircle.tsx";

export {
  Svg2Layers,
  Svg3Layers,
  AmexBadge,
  AILogo,
  CallQueue,
  CallMonitoring,
  CallRouting,
  Circle,
  FiltersLines,
  CheckedCircle,
  Ivr,
  IconIntercom,
  IconMsTeams,
  IconMicrosoft3652022,
  IconAw3,
  IconAzure,
  IconCapsule,
  IconChrome,
  IconDropbox,
  IconFirefox,
  IconGoogle,
  IconGoogleContacts,
  IconGoogleDrive,
  IconHubspot,
  IconPipedrive,
  IconSalesforce,
  IconSlack,
  IconVincere,
  IconVtiger,
  IconZoho,
  LogoActiveCampaign,
  LogoAdobe,
  LogoAfterpay,
  LogoAirbnb,
  LogoAirtable,
  LogoAirtasker,
  LogoAirwallex,
  LogoAmazon,
  LogoAmplitude,
  LogoAsana,
  LogoAtlassian,
  LogoAttentive,
  LogoAutomattic,
  LogoBasecamp,
  LogoBookingCom,
  LogoBraze,
  LogoBrowserStack,
  LogoCalendly,
  LogoCallcabinet,
  LogoCanva,
  LogoCapsule,
  LogoCarta,
  LogoChrome,
  LogoClasspass,
  LogoClearbit,
  LogoCodecademy,
  LogoCoinbase,
  LogoCommsBusiness,
  LogoCommsDealer,
  LogoContentful,
  LogoCultureAmp,
  LogoCustomerIo,
  LogoDatabricks,
  LogoDescript,
  LogoDiscord,
  LogoDocker,
  LogoDocusign,
  LogoDoorDash,
  LogoDribbble,
  LogoDrips,
  LogoDropbox,
  LogoElastic,
  LogoEvernote,
  LogoFigma,
  LogoFirefoxBrowser,
  LogoFivetran,
  LogoFramer,
  LogoFreshworks,
  LogoGhost,
  LogoGitHub,
  LogoGitlab,
  LogoGong,
  LogoGoogle,
  LogoGrammarly,
  LogoGumroad,
  LogoGusto,
  LogoHashiCorp,
  LogoHellosign,
  LogoHimalayas,
  LogoHopin,
  LogoHotjar,
  LogoHubspot,
  LogoInVision,
  LogoInstagram,
  LogoIntercom,
  LogoLattice,
  LogoLaunchDarkly,
  LogoLinear,
  LogoLoom,
  LogoMailchimp,
  LogoMaze,
  LogoMedium,
  LogoMicrosoft,
  LogoMiro,
  LogoMondayCom,
  LogoMonzo,
  LogoMsTeams,
  LogoNetflix,
  LogoNotion,
  LogoOffice365,
  LogoOpendoor,
  LogoOutreach,
  LogoPayPal,
  LogoPendo,
  LogoPipedrive,
  LogoPlaid,
  LogoPostman,
  LogoProductboard,
  LogoRazorpay,
  LogoRippling,
  LogoSalesforce,
  LogoSegment,
  LogoShopify,
  LogoSlack,
  LogoSonos,
  LogoSpaceX,
  LogoSplunk,
  LogoSpotify,
  LogoSquare,
  LogoSquarespace,
  LogoStripe,
  LogoTesla,
  LogoTinder,
  LogoToggle,
  LogoTreehouse,
  LogoTrello,
  LogoTrustpilot,
  LogoTwitch,
  LogoUber,
  LogoUpwork,
  LogoVincare,
  LogoWealthsimple,
  LogoWebflow,
  LogoWhatsapp,
  LogoXero,
  LogoYouTube,
  LogoZapier,
  LogoZoho,
  LogoZoom,
  LogoAppleSafariAr211,
  LogoReapitLogo1,
  LogoVtiger,
  MaestroBadge,
  MasterCardBadge,
  PaypalBadge,
  VisaBadge,
  Wallboards,
  Activity,
  Airplay,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AmexBlock,
  Anchor,
  Aperture,
  AppstoreCard,
  Archive,
  ArrowDownCircle,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowDown,
  ArrowLeftCircle,
  ArrowLeft,
  ArrowRightCircle,
  ArrowRight,
  ArrowUpCircle,
  ArrowUpLeft,
  ArrowUpRight,
  ArrowUp,
  AtSign,
  Award,
  BarChart2,
  BarChart,
  BatteryCharging,
  Battery,
  BellOff,
  Bell,
  Bluetooth,
  Bold,
  BookOpen,
  Book,
  Bookmark,
  Box,
  Briefcase,
  Calendar,
  CameraOff,
  Camera,
  Cast,
  CheckCircle,
  CheckSquare,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  Chrome,
  Clipboard,
  Clock,
  CloudDrizzle,
  CloudLightning,
  CloudOff,
  CloudRain,
  CloudSnow,
  Cloud,
  Code,
  Codepen,
  Codesandbox,
  Coffee,
  CoinStack,
  Coins,
  Columns,
  Command,
  Compass,
  Copy,
  CornerDownLeft,
  CornerDownRight,
  CornerLeftDown,
  CornerLeftUp,
  CornerRightDown,
  CornerRightUp,
  CornerUpLeft,
  CornerUpRight,
  Cpu,
  CreditCard,
  Crop,
  Crosshair,
  Database,
  Delete,
  Disc,
  DivideCircle,
  DivideSquare,
  Divide,
  DollarSign,
  DownloadCloud,
  Download,
  Dribbble,
  Droplet,
  Edit2,
  Edit3,
  Edit,
  ExternalLink,
  EyeOff,
  Eye,
  FacebookGrey,
  Facebook,
  FastForward,
  Feather,
  Figma,
  FileMinus,
  FilePlus,
  FileText,
  File,
  Film,
  Filter,
  Flag,
  FolderMinus,
  FolderPlus,
  Folder,
  Framer,
  Frown,
  Gift,
  GitBranch,
  GitCommit,
  GitMerge,
  GitPullRequest,
  Github,
  Gitlab,
  Globe,
  Google,
  GoogleplayCard,
  Gov,
  Grid,
  HardDrive,
  Hash,
  Headphones,
  Heart,
  HelpCircle,
  Hexagon,
  Home,
  Image,
  Inbox,
  Info,
  InstagramGrey,
  Instagram,
  Iso22301,
  Iso27001,
  Italic,
  Key,
  Layout,
  LifeBuoy,
  Link2,
  Link,
  LinkedinGrey,
  Linkedin,
  List,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Map,
  MastercardBlock,
  Maximize2,
  Maximize,
  Meh,
  Menu2,
  Menu,
  MessageCircle,
  MessageSquare,
  MicOff,
  Mic,
  Microsoft,
  Minimize2,
  Minimize,
  MinusCircle,
  MinusSquare,
  Minus,
  MonitorMobbile,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  MousePointer,
  Move,
  Music,
  Navigation2,
  Navigation,
  Octagon,
  Package,
  Paperclip,
  PauseCircle,
  Pause,
  PaypalBlock,
  PenTool,
  Percent,
  PhoneCall,
  PhoneForwarded,
  PhoneIncoming,
  PhoneMissed,
  PhoneOff,
  PhoneOutgoing,
  Phone,
  PieChart,
  PlayCircle,
  Play,
  PlusCircle,
  PlusSquare,
  Plus,
  Pocket,
  Power,
  Printer,
  Radio,
  RefreshCcw,
  RefreshCw,
  Repeat,
  Rewind,
  Rocket,
  RotateCcw,
  RotateCw,
  Rss,
  Save,
  Scissors,
  Search,
  Send,
  Server,
  Settings,
  Share2,
  Share,
  ShieldOff,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Shuffle,
  Sidebar,
  SkipBack,
  SkipForward,
  Slack,
  SlashDivider,
  Slash,
  Sliders,
  Smartphone,
  Smile,
  Speaker,
  Square,
  Star,
  StopCircle,
  Sun,
  Sunrise,
  Sunset,
  Tablet,
  Tag,
  Target,
  Terminal,
  Thermometer,
  ThumbsDown,
  ThumbsUp,
  ToggleLeft,
  ToggleRight,
  Tool,
  Trash2,
  Trash,
  Trello,
  TrendingDown,
  TrendingUp,
  Triangle,
  Truck,
  Tv,
  Twitch,
  Twitter,
  Type,
  Umbrella,
  Underline,
  Unlock,
  UploadCloud,
  Upload,
  UserCheck,
  UserMinus,
  UserPlus,
  UserX,
  User,
  Users,
  VideoOff,
  Video,
  VisaBlock,
  Voicemail,
  Volume1,
  Volume2,
  VolumeX,
  Volume,
  Watch,
  WifiOff,
  Wifi,
  Wind,
  XCircle,
  XGrey,
  XOctagon,
  XSquare,
  X,
  YoutubeGrey,
  Youtube,
  ZapOff,
  Zap,
  ZoomIn,
  ZoomOut,
  CyberEssentials,
};

export type IconItem = {
  label: string;
  key: string;
  value: React.FC<React.SVGProps<SVGSVGElement>>;
};
export const iconsArray: IconItem[] = [
  { label: "Svg2 Layers", key: "Svg2Layers", value: Svg2Layers },
  { label: "Svg3 Layers", key: "Svg3Layers", value: Svg3Layers },
  { label: "Amex Badge", key: "AmexBadge", value: AmexBadge },
  { label: "Call Queue", key: "CallQueue", value: CallQueue },
  { label: "Call Monitoring", key: "CallMonitoring", value: CallMonitoring },
  { label: "Call Routing", key: "CallRouting", value: CallRouting },
  { label: "Circle", key: "Circle", value: Circle },
  { label: "Checked Circle", key: "CheckedCircle", value: CheckedCircle },
  { label: "Filters Lines", key: "FiltersLines", value: FiltersLines },
  { label: "Ivr", key: "Ivr", value: Ivr },
  { label: "Icon Intercom", key: "IconIntercom", value: IconIntercom },
  { label: "Icon Ms Teams", key: "IconMsTeams", value: IconMsTeams },
  {
    label: "Icon Microsoft3652022",
    key: "IconMicrosoft3652022",
    value: IconMicrosoft3652022,
  },
  { label: "Cyber Essentials", key: "CyberEssentials", value: CyberEssentials },
  { label: "Icon Aw3", key: "IconAw3", value: IconAw3 },
  { label: "Icon Azure", key: "IconAzure", value: IconAzure },
  { label: "Icon Capsule", key: "IconCapsule", value: IconCapsule },
  { label: "Icon Chrome", key: "IconChrome", value: IconChrome },
  { label: "Icon Dropbox", key: "IconDropbox", value: IconDropbox },
  { label: "Icon Firefox", key: "IconFirefox", value: IconFirefox },
  { label: "Icon Google", key: "IconGoogle", value: IconGoogle },
  {
    label: "Icon Google Contacts",
    key: "IconGoogleContacts",
    value: IconGoogleContacts,
  },
  {
    label: "Icon Google Drive",
    key: "IconGoogleDrive",
    value: IconGoogleDrive,
  },
  { label: "Icon Hubspot", key: "IconHubspot", value: IconHubspot },
  { label: "Icon Pipedrive", key: "IconPipedrive", value: IconPipedrive },
  { label: "Icon Salesforce", key: "IconSalesforce", value: IconSalesforce },
  { label: "Icon Slack", key: "IconSlack", value: IconSlack },
  { label: "Icon Vincere", key: "IconVincere", value: IconVincere },
  { label: "Icon Vtiger", key: "IconVtiger", value: IconVtiger },
  { label: "Icon Zoho", key: "IconZoho", value: IconZoho },
  {
    label: "Logo Active Campaign",
    key: "LogoActiveCampaign",
    value: LogoActiveCampaign,
  },
  { label: "Logo Adobe", key: "LogoAdobe", value: LogoAdobe },
  { label: "Logo Afterpay", key: "LogoAfterpay", value: LogoAfterpay },
  { label: "Logo Airbnb", key: "LogoAirbnb", value: LogoAirbnb },
  { label: "Logo Airtable", key: "LogoAirtable", value: LogoAirtable },
  { label: "Logo Airtasker", key: "LogoAirtasker", value: LogoAirtasker },
  { label: "Logo Airwallex", key: "LogoAirwallex", value: LogoAirwallex },
  { label: "Logo Amazon", key: "LogoAmazon", value: LogoAmazon },
  { label: "Logo Amplitude", key: "LogoAmplitude", value: LogoAmplitude },
  { label: "Logo Asana", key: "LogoAsana", value: LogoAsana },
  { label: "Logo Atlassian", key: "LogoAtlassian", value: LogoAtlassian },
  { label: "Logo Attentive", key: "LogoAttentive", value: LogoAttentive },
  { label: "Logo Automattic", key: "LogoAutomattic", value: LogoAutomattic },
  { label: "Logo Basecamp", key: "LogoBasecamp", value: LogoBasecamp },
  { label: "Logo Booking Com", key: "LogoBookingCom", value: LogoBookingCom },
  { label: "Logo Braze", key: "LogoBraze", value: LogoBraze },
  {
    label: "Logo Browser Stack",
    key: "LogoBrowserStack",
    value: LogoBrowserStack,
  },
  { label: "Logo Calendly", key: "LogoCalendly", value: LogoCalendly },
  { label: "Logo Callcabinet", key: "LogoCallcabinet", value: LogoCallcabinet },
  { label: "Logo Canva", key: "LogoCanva", value: LogoCanva },
  { label: "Logo Capsule", key: "LogoCapsule", value: LogoCapsule },
  { label: "Logo Carta", key: "LogoCarta", value: LogoCarta },
  { label: "Logo Chrome", key: "LogoChrome", value: LogoChrome },
  { label: "Logo Classpass", key: "LogoClasspass", value: LogoClasspass },
  { label: "Logo Clearbit", key: "LogoClearbit", value: LogoClearbit },
  { label: "Logo Codecademy", key: "LogoCodecademy", value: LogoCodecademy },
  { label: "Logo Coinbase", key: "LogoCoinbase", value: LogoCoinbase },
  {
    label: "Logo Comms Business",
    key: "LogoCommsBusiness",
    value: LogoCommsBusiness,
  },
  {
    label: "Logo Comms Dealer",
    key: "LogoCommsDealer",
    value: LogoCommsDealer,
  },
  { label: "Logo Contentful", key: "LogoContentful", value: LogoContentful },
  { label: "Logo Culture Amp", key: "LogoCultureAmp", value: LogoCultureAmp },
  { label: "Logo Customer Io", key: "LogoCustomerIo", value: LogoCustomerIo },
  { label: "Logo Databricks", key: "LogoDatabricks", value: LogoDatabricks },
  { label: "Logo Descript", key: "LogoDescript", value: LogoDescript },
  { label: "Logo Discord", key: "LogoDiscord", value: LogoDiscord },
  { label: "Logo Docker", key: "LogoDocker", value: LogoDocker },
  { label: "Logo Docusign", key: "LogoDocusign", value: LogoDocusign },
  { label: "Logo Door Dash", key: "LogoDoorDash", value: LogoDoorDash },
  { label: "Logo Dribbble", key: "LogoDribbble", value: LogoDribbble },
  { label: "Logo Drips", key: "LogoDrips", value: LogoDrips },
  { label: "Logo Dropbox", key: "LogoDropbox", value: LogoDropbox },
  { label: "Logo Elastic", key: "LogoElastic", value: LogoElastic },
  { label: "Logo Evernote", key: "LogoEvernote", value: LogoEvernote },
  { label: "Logo Figma", key: "LogoFigma", value: LogoFigma },
  {
    label: "Logo Firefox Browser",
    key: "LogoFirefoxBrowser",
    value: LogoFirefoxBrowser,
  },
  { label: "Logo Fivetran", key: "LogoFivetran", value: LogoFivetran },
  { label: "Logo Framer", key: "LogoFramer", value: LogoFramer },
  { label: "Logo Freshworks", key: "LogoFreshworks", value: LogoFreshworks },
  { label: "Logo Ghost", key: "LogoGhost", value: LogoGhost },
  { label: "Logo Git Hub", key: "LogoGitHub", value: LogoGitHub },
  { label: "Logo Gitlab", key: "LogoGitlab", value: LogoGitlab },
  { label: "Logo Gong", key: "LogoGong", value: LogoGong },
  { label: "Logo Google", key: "LogoGoogle", value: LogoGoogle },
  { label: "Logo Grammarly", key: "LogoGrammarly", value: LogoGrammarly },
  { label: "Logo Gumroad", key: "LogoGumroad", value: LogoGumroad },
  { label: "Logo Gusto", key: "LogoGusto", value: LogoGusto },
  { label: "Logo Hashi Corp", key: "LogoHashiCorp", value: LogoHashiCorp },
  { label: "Logo Hellosign", key: "LogoHellosign", value: LogoHellosign },
  { label: "Logo Himalayas", key: "LogoHimalayas", value: LogoHimalayas },
  { label: "Logo Hopin", key: "LogoHopin", value: LogoHopin },
  { label: "Logo Hotjar", key: "LogoHotjar", value: LogoHotjar },
  { label: "Logo Hubspot", key: "LogoHubspot", value: LogoHubspot },
  { label: "Logo In Vision", key: "LogoInVision", value: LogoInVision },
  { label: "Logo Instagram", key: "LogoInstagram", value: LogoInstagram },
  { label: "Logo Intercom", key: "LogoIntercom", value: LogoIntercom },
  { label: "Logo Lattice", key: "LogoLattice", value: LogoLattice },
  {
    label: "Logo Launch Darkly",
    key: "LogoLaunchDarkly",
    value: LogoLaunchDarkly,
  },
  { label: "Logo Linear", key: "LogoLinear", value: LogoLinear },
  { label: "Logo Loom", key: "LogoLoom", value: LogoLoom },
  { label: "Logo Mailchimp", key: "LogoMailchimp", value: LogoMailchimp },
  { label: "Logo Maze", key: "LogoMaze", value: LogoMaze },
  { label: "Logo Medium", key: "LogoMedium", value: LogoMedium },
  { label: "Logo Microsoft", key: "LogoMicrosoft", value: LogoMicrosoft },
  { label: "Logo Miro", key: "LogoMiro", value: LogoMiro },
  { label: "Logo Monday Com", key: "LogoMondayCom", value: LogoMondayCom },
  { label: "Logo Monzo", key: "LogoMonzo", value: LogoMonzo },
  { label: "Logo Ms Teams", key: "LogoMsTeams", value: LogoMsTeams },
  { label: "Logo Netflix", key: "LogoNetflix", value: LogoNetflix },
  { label: "Logo Notion", key: "LogoNotion", value: LogoNotion },
  { label: "Logo Office365", key: "LogoOffice365", value: LogoOffice365 },
  { label: "Logo Opendoor", key: "LogoOpendoor", value: LogoOpendoor },
  { label: "Logo Outreach", key: "LogoOutreach", value: LogoOutreach },
  { label: "Logo Pay Pal", key: "LogoPayPal", value: LogoPayPal },
  { label: "Logo Pendo", key: "LogoPendo", value: LogoPendo },
  { label: "Logo Pipedrive", key: "LogoPipedrive", value: LogoPipedrive },
  { label: "Logo Plaid", key: "LogoPlaid", value: LogoPlaid },
  { label: "Logo Postman", key: "LogoPostman", value: LogoPostman },
  {
    label: "Logo Productboard",
    key: "LogoProductboard",
    value: LogoProductboard,
  },
  { label: "Logo Razorpay", key: "LogoRazorpay", value: LogoRazorpay },
  { label: "Logo Rippling", key: "LogoRippling", value: LogoRippling },
  { label: "Logo Salesforce", key: "LogoSalesforce", value: LogoSalesforce },
  { label: "Logo Segment", key: "LogoSegment", value: LogoSegment },
  { label: "Logo Shopify", key: "LogoShopify", value: LogoShopify },
  { label: "Logo Slack", key: "LogoSlack", value: LogoSlack },
  { label: "Logo Sonos", key: "LogoSonos", value: LogoSonos },
  { label: "Logo Space X", key: "LogoSpaceX", value: LogoSpaceX },
  { label: "Logo Splunk", key: "LogoSplunk", value: LogoSplunk },
  { label: "Logo Spotify", key: "LogoSpotify", value: LogoSpotify },
  { label: "Logo Square", key: "LogoSquare", value: LogoSquare },
  { label: "Logo Squarespace", key: "LogoSquarespace", value: LogoSquarespace },
  { label: "Logo Stripe", key: "LogoStripe", value: LogoStripe },
  { label: "Logo Tesla", key: "LogoTesla", value: LogoTesla },
  { label: "Logo Tinder", key: "LogoTinder", value: LogoTinder },
  { label: "Logo Toggle", key: "LogoToggle", value: LogoToggle },
  { label: "Logo Treehouse", key: "LogoTreehouse", value: LogoTreehouse },
  { label: "Logo Trello", key: "LogoTrello", value: LogoTrello },
  { label: "Logo Trustpilot", key: "LogoTrustpilot", value: LogoTrustpilot },
  { label: "Logo Twitch", key: "LogoTwitch", value: LogoTwitch },
  { label: "Logo Uber", key: "LogoUber", value: LogoUber },
  { label: "Logo Upwork", key: "LogoUpwork", value: LogoUpwork },
  { label: "Logo Vincare", key: "LogoVincare", value: LogoVincare },
  {
    label: "Logo Wealthsimple",
    key: "LogoWealthsimple",
    value: LogoWealthsimple,
  },
  { label: "Logo Webflow", key: "LogoWebflow", value: LogoWebflow },
  { label: "Logo Whatsapp", key: "LogoWhatsapp", value: LogoWhatsapp },
  { label: "Logo Xero", key: "LogoXero", value: LogoXero },
  { label: "Logo You Tube", key: "LogoYouTube", value: LogoYouTube },
  { label: "Logo Zapier", key: "LogoZapier", value: LogoZapier },
  { label: "Logo Zoho", key: "LogoZoho", value: LogoZoho },
  { label: "Logo Zoom", key: "LogoZoom", value: LogoZoom },
  {
    label: "Logo Apple Safari Ar211",
    key: "LogoAppleSafariAr211",
    value: LogoAppleSafariAr211,
  },
  {
    label: "Logo Reapit Logo1",
    key: "LogoReapitLogo1",
    value: LogoReapitLogo1,
  },
  { label: "Logo Vtiger", key: "LogoVtiger", value: LogoVtiger },
  { label: "Maestro Badge", key: "MaestroBadge", value: MaestroBadge },
  {
    label: "Master Card Badge",
    key: "MasterCardBadge",
    value: MasterCardBadge,
  },
  { label: "Paypal Badge", key: "PaypalBadge", value: PaypalBadge },
  { label: "Visa Badge", key: "VisaBadge", value: VisaBadge },
  { label: "Wallboards", key: "Wallboards", value: Wallboards },
  { label: "Activity", key: "Activity", value: Activity },
  { label: "Airplay", key: "Airplay", value: Airplay },
  { label: "Alert Circle", key: "AlertCircle", value: AlertCircle },
  { label: "Alert Octagon", key: "AlertOctagon", value: AlertOctagon },
  { label: "Alert Triangle", key: "AlertTriangle", value: AlertTriangle },
  { label: "Align Center", key: "AlignCenter", value: AlignCenter },
  { label: "Align Justify", key: "AlignJustify", value: AlignJustify },
  { label: "Align Left", key: "AlignLeft", value: AlignLeft },
  { label: "Align Right", key: "AlignRight", value: AlignRight },
  { label: "Amex Block", key: "AmexBlock", value: AmexBlock },
  { label: "Anchor", key: "Anchor", value: Anchor },
  { label: "Aperture", key: "Aperture", value: Aperture },
  { label: "Appstore Card", key: "AppstoreCard", value: AppstoreCard },
  { label: "Archive", key: "Archive", value: Archive },
  {
    label: "Arrow Down Circle",
    key: "ArrowDownCircle",
    value: ArrowDownCircle,
  },
  { label: "Arrow Down Left", key: "ArrowDownLeft", value: ArrowDownLeft },
  { label: "Arrow Down Right", key: "ArrowDownRight", value: ArrowDownRight },
  { label: "Arrow Down", key: "ArrowDown", value: ArrowDown },
  {
    label: "Arrow Left Circle",
    key: "ArrowLeftCircle",
    value: ArrowLeftCircle,
  },
  { label: "Arrow Left", key: "ArrowLeft", value: ArrowLeft },
  {
    label: "Arrow Right Circle",
    key: "ArrowRightCircle",
    value: ArrowRightCircle,
  },
  { label: "Arrow Right", key: "ArrowRight", value: ArrowRight },
  { label: "AI Logo", key: "AILogo", value: AILogo },
  { label: "Arrow Up Circle", key: "ArrowUpCircle", value: ArrowUpCircle },
  { label: "Arrow Up Left", key: "ArrowUpLeft", value: ArrowUpLeft },
  { label: "Arrow Up Right", key: "ArrowUpRight", value: ArrowUpRight },
  { label: "Arrow Up", key: "ArrowUp", value: ArrowUp },
  { label: "At Sign", key: "AtSign", value: AtSign },
  { label: "Award", key: "Award", value: Award },
  { label: "Bar Chart2", key: "BarChart2", value: BarChart2 },
  { label: "Bar Chart", key: "BarChart", value: BarChart },
  { label: "Battery Charging", key: "BatteryCharging", value: BatteryCharging },
  { label: "Battery", key: "Battery", value: Battery },
  { label: "Bell Off", key: "BellOff", value: BellOff },
  { label: "Bell", key: "Bell", value: Bell },
  { label: "Bluetooth", key: "Bluetooth", value: Bluetooth },
  { label: "Bold", key: "Bold", value: Bold },
  { label: "Book Open", key: "BookOpen", value: BookOpen },
  { label: "Book", key: "Book", value: Book },
  { label: "Bookmark", key: "Bookmark", value: Bookmark },
  { label: "Box", key: "Box", value: Box },
  { label: "Briefcase", key: "Briefcase", value: Briefcase },
  { label: "Calendar", key: "Calendar", value: Calendar },
  { label: "Camera Off", key: "CameraOff", value: CameraOff },
  { label: "Camera", key: "Camera", value: Camera },
  { label: "Cast", key: "Cast", value: Cast },
  { label: "Check Circle", key: "CheckCircle", value: CheckCircle },
  { label: "Check Square", key: "CheckSquare", value: CheckSquare },
  { label: "Check", key: "Check", value: Check },
  { label: "Chevron Down", key: "ChevronDown", value: ChevronDown },
  { label: "Chevron Left", key: "ChevronLeft", value: ChevronLeft },
  { label: "Chevron Right", key: "ChevronRight", value: ChevronRight },
  { label: "Chevron Up", key: "ChevronUp", value: ChevronUp },
  { label: "Chevrons Down", key: "ChevronsDown", value: ChevronsDown },
  { label: "Chevrons Left", key: "ChevronsLeft", value: ChevronsLeft },
  { label: "Chevrons Right", key: "ChevronsRight", value: ChevronsRight },
  { label: "Chevrons Up", key: "ChevronsUp", value: ChevronsUp },
  { label: "Chrome", key: "Chrome", value: Chrome },
  { label: "Clipboard", key: "Clipboard", value: Clipboard },
  { label: "Clock", key: "Clock", value: Clock },
  { label: "Cloud Drizzle", key: "CloudDrizzle", value: CloudDrizzle },
  { label: "Cloud Lightning", key: "CloudLightning", value: CloudLightning },
  { label: "Cloud Off", key: "CloudOff", value: CloudOff },
  { label: "Cloud Rain", key: "CloudRain", value: CloudRain },
  { label: "Cloud Snow", key: "CloudSnow", value: CloudSnow },
  { label: "Cloud", key: "Cloud", value: Cloud },
  { label: "Code", key: "Code", value: Code },
  { label: "Codepen", key: "Codepen", value: Codepen },
  { label: "Codesandbox", key: "Codesandbox", value: Codesandbox },
  { label: "Coffee", key: "Coffee", value: Coffee },
  { label: "Coin Stack", key: "CoinStack", value: CoinStack },
  { label: "Coins", key: "Coins", value: Coins },
  { label: "Columns", key: "Columns", value: Columns },
  { label: "Command", key: "Command", value: Command },
  { label: "Compass", key: "Compass", value: Compass },
  { label: "Copy", key: "Copy", value: Copy },
  { label: "Corner Down Left", key: "CornerDownLeft", value: CornerDownLeft },
  {
    label: "Corner Down Right",
    key: "CornerDownRight",
    value: CornerDownRight,
  },
  { label: "Corner Left Down", key: "CornerLeftDown", value: CornerLeftDown },
  { label: "Corner Left Up", key: "CornerLeftUp", value: CornerLeftUp },
  {
    label: "Corner Right Down",
    key: "CornerRightDown",
    value: CornerRightDown,
  },
  { label: "Corner Right Up", key: "CornerRightUp", value: CornerRightUp },
  { label: "Corner Up Left", key: "CornerUpLeft", value: CornerUpLeft },
  { label: "Corner Up Right", key: "CornerUpRight", value: CornerUpRight },
  { label: "Cpu", key: "Cpu", value: Cpu },
  { label: "Credit Card", key: "CreditCard", value: CreditCard },
  { label: "Crop", key: "Crop", value: Crop },
  { label: "Crosshair", key: "Crosshair", value: Crosshair },
  { label: "Database", key: "Database", value: Database },
  { label: "Delete", key: "Delete", value: Delete },
  { label: "Disc", key: "Disc", value: Disc },
  { label: "Divide Circle", key: "DivideCircle", value: DivideCircle },
  { label: "Divide Square", key: "DivideSquare", value: DivideSquare },
  { label: "Divide", key: "Divide", value: Divide },
  { label: "Dollar Sign", key: "DollarSign", value: DollarSign },
  { label: "Download Cloud", key: "DownloadCloud", value: DownloadCloud },
  { label: "Download", key: "Download", value: Download },
  { label: "Dribbble", key: "Dribbble", value: Dribbble },
  { label: "Droplet", key: "Droplet", value: Droplet },
  { label: "Edit2", key: "Edit2", value: Edit2 },
  { label: "Edit3", key: "Edit3", value: Edit3 },
  { label: "Edit", key: "Edit", value: Edit },
  { label: "External Link", key: "ExternalLink", value: ExternalLink },
  { label: "Eye Off", key: "EyeOff", value: EyeOff },
  { label: "Eye", key: "Eye", value: Eye },
  { label: "Facebook Grey", key: "FacebookGrey", value: FacebookGrey },
  { label: "Facebook", key: "Facebook", value: Facebook },
  { label: "Fast Forward", key: "FastForward", value: FastForward },
  { label: "Feather", key: "Feather", value: Feather },
  { label: "Figma", key: "Figma", value: Figma },
  { label: "File Minus", key: "FileMinus", value: FileMinus },
  { label: "File Plus", key: "FilePlus", value: FilePlus },
  { label: "File Text", key: "FileText", value: FileText },
  { label: "File", key: "File", value: File },
  { label: "Film", key: "Film", value: Film },
  { label: "Filter", key: "Filter", value: Filter },
  { label: "Flag", key: "Flag", value: Flag },
  { label: "Folder Minus", key: "FolderMinus", value: FolderMinus },
  { label: "Folder Plus", key: "FolderPlus", value: FolderPlus },
  { label: "Folder", key: "Folder", value: Folder },
  { label: "Framer", key: "Framer", value: Framer },
  { label: "Frown", key: "Frown", value: Frown },
  { label: "Gift", key: "Gift", value: Gift },
  { label: "Git Branch", key: "GitBranch", value: GitBranch },
  { label: "Git Commit", key: "GitCommit", value: GitCommit },
  { label: "Git Merge", key: "GitMerge", value: GitMerge },
  { label: "Git Pull Request", key: "GitPullRequest", value: GitPullRequest },
  { label: "Github", key: "Github", value: Github },
  { label: "Gitlab", key: "Gitlab", value: Gitlab },
  { label: "Globe", key: "Globe", value: Globe },
  { label: "Google", key: "Google", value: Google },
  { label: "Googleplay Card", key: "GoogleplayCard", value: GoogleplayCard },
  { label: "Gov", key: "Gov", value: Gov },
  { label: "Grid", key: "Grid", value: Grid },
  { label: "Hard Drive", key: "HardDrive", value: HardDrive },
  { label: "Hash", key: "Hash", value: Hash },
  { label: "Headphones", key: "Headphones", value: Headphones },
  { label: "Heart", key: "Heart", value: Heart },
  { label: "Help Circle", key: "HelpCircle", value: HelpCircle },
  { label: "Hexagon", key: "Hexagon", value: Hexagon },
  { label: "Home", key: "Home", value: Home },
  { label: "Image", key: "Image", value: Image },
  { label: "Inbox", key: "Inbox", value: Inbox },
  { label: "Info", key: "Info", value: Info },
  { label: "Instagram Grey", key: "InstagramGrey", value: InstagramGrey },
  { label: "Instagram", key: "Instagram", value: Instagram },
  { label: "Iso22301", key: "Iso22301", value: Iso22301 },
  { label: "Iso27001", key: "Iso27001", value: Iso27001 },
  { label: "Italic", key: "Italic", value: Italic },
  { label: "Key", key: "Key", value: Key },
  { label: "Layout", key: "Layout", value: Layout },
  { label: "Life Buoy", key: "LifeBuoy", value: LifeBuoy },
  { label: "Link2", key: "Link2", value: Link2 },
  { label: "Link", key: "Link", value: Link },
  { label: "Linkedin Grey", key: "LinkedinGrey", value: LinkedinGrey },
  { label: "Linkedin", key: "Linkedin", value: Linkedin },
  { label: "List", key: "List", value: List },
  { label: "Loader", key: "Loader", value: Loader },
  { label: "Lock", key: "Lock", value: Lock },
  { label: "Log In", key: "LogIn", value: LogIn },
  { label: "Log Out", key: "LogOut", value: LogOut },
  { label: "Mail", key: "Mail", value: Mail },
  { label: "Map Pin", key: "MapPin", value: MapPin },
  { label: "Map", key: "Map", value: Map },
  { label: "Mastercard Block", key: "MastercardBlock", value: MastercardBlock },
  { label: "Maximize2", key: "Maximize2", value: Maximize2 },
  { label: "Maximize", key: "Maximize", value: Maximize },
  { label: "Meh", key: "Meh", value: Meh },
  { label: "Menu2", key: "Menu2", value: Menu2 },
  { label: "Menu", key: "Menu", value: Menu },
  { label: "Message Circle", key: "MessageCircle", value: MessageCircle },
  { label: "Message Square", key: "MessageSquare", value: MessageSquare },
  { label: "Mic Off", key: "MicOff", value: MicOff },
  { label: "Mic", key: "Mic", value: Mic },
  { label: "Microsoft", key: "Microsoft", value: Microsoft },
  { label: "Minimize2", key: "Minimize2", value: Minimize2 },
  { label: "Minimize", key: "Minimize", value: Minimize },
  { label: "Minus Circle", key: "MinusCircle", value: MinusCircle },
  { label: "Minus Square", key: "MinusSquare", value: MinusSquare },
  { label: "Minus", key: "Minus", value: Minus },
  { label: "Monitor Mobbile", key: "MonitorMobbile", value: MonitorMobbile },
  { label: "Monitor", key: "Monitor", value: Monitor },
  { label: "Moon", key: "Moon", value: Moon },
  { label: "More Horizontal", key: "MoreHorizontal", value: MoreHorizontal },
  { label: "More Vertical", key: "MoreVertical", value: MoreVertical },
  { label: "Mouse Pointer", key: "MousePointer", value: MousePointer },
  { label: "Move", key: "Move", value: Move },
  { label: "Music", key: "Music", value: Music },
  { label: "Navigation2", key: "Navigation2", value: Navigation2 },
  { label: "Navigation", key: "Navigation", value: Navigation },
  { label: "Octagon", key: "Octagon", value: Octagon },
  { label: "Package", key: "Package", value: Package },
  { label: "Paperclip", key: "Paperclip", value: Paperclip },
  { label: "Pause Circle", key: "PauseCircle", value: PauseCircle },
  { label: "Pause", key: "Pause", value: Pause },
  { label: "Paypal Block", key: "PaypalBlock", value: PaypalBlock },
  { label: "Pen Tool", key: "PenTool", value: PenTool },
  { label: "Percent", key: "Percent", value: Percent },
  { label: "Phone Call", key: "PhoneCall", value: PhoneCall },
  { label: "Phone Forwarded", key: "PhoneForwarded", value: PhoneForwarded },
  { label: "Phone Incoming", key: "PhoneIncoming", value: PhoneIncoming },
  { label: "Phone Missed", key: "PhoneMissed", value: PhoneMissed },
  { label: "Phone Off", key: "PhoneOff", value: PhoneOff },
  { label: "Phone Outgoing", key: "PhoneOutgoing", value: PhoneOutgoing },
  { label: "Phone", key: "Phone", value: Phone },
  { label: "Pie Chart", key: "PieChart", value: PieChart },
  { label: "Play Circle", key: "PlayCircle", value: PlayCircle },
  { label: "Play", key: "Play", value: Play },
  { label: "Plus Circle", key: "PlusCircle", value: PlusCircle },
  { label: "Plus Square", key: "PlusSquare", value: PlusSquare },
  { label: "Plus", key: "Plus", value: Plus },
  { label: "Pocket", key: "Pocket", value: Pocket },
  { label: "Power", key: "Power", value: Power },
  { label: "Printer", key: "Printer", value: Printer },
  { label: "Radio", key: "Radio", value: Radio },
  { label: "Refresh Ccw", key: "RefreshCcw", value: RefreshCcw },
  { label: "Refresh Cw", key: "RefreshCw", value: RefreshCw },
  { label: "Repeat", key: "Repeat", value: Repeat },
  { label: "Rewind", key: "Rewind", value: Rewind },
  { label: "Rocket", key: "Rocket", value: Rocket },
  { label: "Rotate Ccw", key: "RotateCcw", value: RotateCcw },
  { label: "Rotate Cw", key: "RotateCw", value: RotateCw },
  { label: "Rss", key: "Rss", value: Rss },
  { label: "Save", key: "Save", value: Save },
  { label: "Scissors", key: "Scissors", value: Scissors },
  { label: "Search", key: "Search", value: Search },
  { label: "Send", key: "Send", value: Send },
  { label: "Server", key: "Server", value: Server },
  { label: "Settings", key: "Settings", value: Settings },
  { label: "Share2", key: "Share2", value: Share2 },
  { label: "Share", key: "Share", value: Share },
  { label: "Shield Off", key: "ShieldOff", value: ShieldOff },
  { label: "Shield", key: "Shield", value: Shield },
  { label: "Shopping Bag", key: "ShoppingBag", value: ShoppingBag },
  { label: "Shopping Cart", key: "ShoppingCart", value: ShoppingCart },
  { label: "Shuffle", key: "Shuffle", value: Shuffle },
  { label: "Sidebar", key: "Sidebar", value: Sidebar },
  { label: "Skip Back", key: "SkipBack", value: SkipBack },
  { label: "Skip Forward", key: "SkipForward", value: SkipForward },
  { label: "Slack", key: "Slack", value: Slack },
  { label: "Slash Divider", key: "SlashDivider", value: SlashDivider },
  { label: "Slash", key: "Slash", value: Slash },
  { label: "Sliders", key: "Sliders", value: Sliders },
  { label: "Smartphone", key: "Smartphone", value: Smartphone },
  { label: "Smile", key: "Smile", value: Smile },
  { label: "Speaker", key: "Speaker", value: Speaker },
  { label: "Square", key: "Square", value: Square },
  { label: "Star", key: "Star", value: Star },
  { label: "Stop Circle", key: "StopCircle", value: StopCircle },
  { label: "Sun", key: "Sun", value: Sun },
  { label: "Sunrise", key: "Sunrise", value: Sunrise },
  { label: "Sunset", key: "Sunset", value: Sunset },
  { label: "Tablet", key: "Tablet", value: Tablet },
  { label: "Tag", key: "Tag", value: Tag },
  { label: "Target", key: "Target", value: Target },
  { label: "Terminal", key: "Terminal", value: Terminal },
  { label: "Thermometer", key: "Thermometer", value: Thermometer },
  { label: "Thumbs Down", key: "ThumbsDown", value: ThumbsDown },
  { label: "Thumbs Up", key: "ThumbsUp", value: ThumbsUp },
  { label: "Toggle Left", key: "ToggleLeft", value: ToggleLeft },
  { label: "Toggle Right", key: "ToggleRight", value: ToggleRight },
  { label: "Tool", key: "Tool", value: Tool },
  { label: "Trash2", key: "Trash2", value: Trash2 },
  { label: "Trash", key: "Trash", value: Trash },
  { label: "Trello", key: "Trello", value: Trello },
  { label: "Trending Down", key: "TrendingDown", value: TrendingDown },
  { label: "Trending Up", key: "TrendingUp", value: TrendingUp },
  { label: "Triangle", key: "Triangle", value: Triangle },
  { label: "Truck", key: "Truck", value: Truck },
  { label: "Tv", key: "Tv", value: Tv },
  { label: "Twitch", key: "Twitch", value: Twitch },
  { label: "Twitter", key: "Twitter", value: Twitter },
  { label: "Type", key: "Type", value: Type },
  { label: "Umbrella", key: "Umbrella", value: Umbrella },
  { label: "Underline", key: "Underline", value: Underline },
  { label: "Unlock", key: "Unlock", value: Unlock },
  { label: "Upload Cloud", key: "UploadCloud", value: UploadCloud },
  { label: "Upload", key: "Upload", value: Upload },
  { label: "User Check", key: "UserCheck", value: UserCheck },
  { label: "User Minus", key: "UserMinus", value: UserMinus },
  { label: "User Plus", key: "UserPlus", value: UserPlus },
  { label: "User X", key: "UserX", value: UserX },
  { label: "User", key: "User", value: User },
  { label: "Users", key: "Users", value: Users },
  { label: "Video Off", key: "VideoOff", value: VideoOff },
  { label: "Video", key: "Video", value: Video },
  { label: "Visa Block", key: "VisaBlock", value: VisaBlock },
  { label: "Voicemail", key: "Voicemail", value: Voicemail },
  { label: "Volume1", key: "Volume1", value: Volume1 },
  { label: "Volume2", key: "Volume2", value: Volume2 },
  { label: "Volume X", key: "VolumeX", value: VolumeX },
  { label: "Volume", key: "Volume", value: Volume },
  { label: "Watch", key: "Watch", value: Watch },
  { label: "Wifi Off", key: "WifiOff", value: WifiOff },
  { label: "Wifi", key: "Wifi", value: Wifi },
  { label: "Wind", key: "Wind", value: Wind },
  { label: "X Circle", key: "XCircle", value: XCircle },
  { label: "X Grey", key: "XGrey", value: XGrey },
  { label: "X Octagon", key: "XOctagon", value: XOctagon },
  { label: "X Square", key: "XSquare", value: XSquare },
  { label: "X", key: "X", value: X },
  { label: "Youtube Grey", key: "YoutubeGrey", value: YoutubeGrey },
  { label: "Youtube", key: "Youtube", value: Youtube },
  { label: "Zap Off", key: "ZapOff", value: ZapOff },
  { label: "Zap", key: "Zap", value: Zap },
  { label: "Zoom In", key: "ZoomIn", value: ZoomIn },
  { label: "Zoom Out", key: "ZoomOut", value: ZoomOut },
];
